/*
 * @Author: chenqing
 * @Date: 2023-05-17 16:59:33
 * @LastEditors: chenqing
 * @LastEditTime: 2023-06-01 13:55:45
 * @FilePath: /chaojimaHome/App/assets/scripts/modules/subHeader/index.js
 * @Description:
 */
//子导航
$(function () {
  //
  let hoverNavId = "";
  //
  $(".public-sub-header .nav-wrap .nav-item").hover(
    function () {
      hoverNavId = $(this).attr("data-id");
      toggerSubNav();
    },
    function () {
      hoverNavId = "";
      toggerSubNav();
    }
  );
  //
  $(".public-sub-header .sub-nav-group-wrap").hover(
    function () {
      clearTimeout(timeout);
    },
    function () {
      hoverNavId = "";
      toggerSubNav();
    }
  );
  //
  let timeout = null;
  const toggerSubNav = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      hideSubNav();
      if (hoverNavId) {
        const $links = $(
          `.sub-nav-group-item[data-id="${hoverNavId}"] a.sub-nav-item`
        );
        if ($links.length > 0) {
          $(
            `.sub-nav-group-wrap, .sub-nav-group-item[data-id="${hoverNavId}"]`
          ).removeClass("hide");
        }
      }
    }, 100);
  };
  const hideSubNav = () => {
    $(".public-sub-header")
      .find(".sub-nav-group-wrap,.sub-nav-group-item")
      .addClass("hide");
  };
  $(".sub-nav-item").click(function () {
    let activeId;
    // 获取hash值
    const index = location.hash.split("#")[1] || 1;
    // 手动切下面菜单，在当前页href锚点是不会页面跳转的
    $(".tab-list-item").removeClass("line-hover");
    $(".tab-list-item")
      .eq(index - 1)
      .addClass("line-hover");
    $(".tab-content img").removeClass("show");
    // 切换数字三农锚点页面
    activeId = $(".tab-list .tab-list-item")
      .eq(index - 1)
      .attr("data-id");
    $(`.tab-content img[data-id="${activeId}"]`).addClass("show");
    // 切换经典案例锚点页面
    $(".article-list-item").removeClass("show");
    $(".article-list-item")
      .eq(index - 1)
      .addClass("show");
  });
});
